import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { formatVal } from '../../helpers/value'
import { positionDropdown } from '../dropdown'
import { Element } from '../html/element'
import { SelectCustom } from '../selectCustom'
import { PAGE_SIZE_OPTIONS } from './constants'

export const SelectPageSize = ({
  page,
  pageSize,
  total,
  setPageSize,
  pageSizeOptions,
  zIndex,
  scrollId,
}) => {
  const locale = useSelector((state) => state.i18n.locale)
  // Get data
  const getRangeRecords = useMemo(() => {
    const startRange = pageSize * (page - 1) + 1
    let endRange = page * pageSize

    if (endRange > total) {
      endRange = total
    }

    return `${startRange} - ${endRange}`
  }, [page, pageSize, total])

  // Actions
  const onSelectPageSize = (value) => {
    setPageSize(value.label)
  }

  return (
    <div className="dFlex alignItemsCenter">
      <Translate value="common.pagination.ITEMS_PER_PAGE" />:
      <SelectCustom
        className="mx1"
        style={{ fontSize: 12, fontWeight: 600 }}
        activeItem={{ label: pageSize, value: pageSize }}
        data={pageSizeOptions || PAGE_SIZE_OPTIONS}
        chooseItem={onSelectPageSize}
        position={positionDropdown.TOP_START_RIGHT}
        zIndex={zIndex}
        scrollId={scrollId}
      />
      <div>
        <Element elementName="span" className="fw600">
          {getRangeRecords}
        </Element>
        &nbsp;
        <Translate value="common.pagination.OF" />
        &nbsp;
        <Element elementName="span" className="fw600">
          {formatVal(total, locale, false, 0)}
        </Element>
      </div>
    </div>
  )
}
